var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59937 7.89073H3.9327V9.55739H5.59937V7.89073ZM8.9327 7.89073H7.26603V9.55739H8.9327V7.89073ZM12.266 7.89073H10.5994V9.55739H12.266V7.89073ZM13.9327 2.05739H13.0994V0.390728H11.4327V2.05739H4.76603V0.390728H3.09937V2.05739H2.26603C1.34103 2.05739 0.607699 2.80739 0.607699 3.72406L0.599365 15.3907C0.599365 16.3074 1.34103 17.0574 2.26603 17.0574H13.9327C14.8494 17.0574 15.5994 16.3074 15.5994 15.3907V3.72406C15.5994 2.80739 14.8494 2.05739 13.9327 2.05739ZM13.9327 15.3907H2.26603V6.22406H13.9327V15.3907Z",
    fill: "#4079F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.dddb0a37acf3da6907263e096a168d91.svg";
export { ForwardRef as ReactComponent };